var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlatformoverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.725,
    height: 23.647,
    viewBox: "0 0 23.725 23.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.346 -18.374)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.5 18.525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.388,18.6a2.662,2.662,0,0,0-2.625,2.292h-3.7a2.662,2.662,0,1,0,0,.739H51.8A2.662,2.662,0,1,0,54.425,18.6Zm-8.946,4.547a1.922,1.922,0,1,1,1.922-1.922,1.922,1.922,0,0,1-1.922,1.922Zm8.946,0a1.922,1.922,0,1,1,1.922-1.922,1.922,1.922,0,0,1-1.922,1.922Z",
    transform: "translate(-33.798 -18.572)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.262,67.1a2.662,2.662,0,1,0,2.662,2.662A2.662,2.662,0,0,0,21.262,67.1Zm0,4.547a1.922,1.922,0,1,1,1.922-1.922A1.922,1.922,0,0,1,21.262,71.647Z",
    transform: "translate(-18.563 -49.143)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.407,42.381a2.662,2.662,0,0,0-1.479,4.843l-5.323,5.36a2.662,2.662,0,0,0-1.774-1.035V47.667a2.662,2.662,0,1,0-.739,0v3.881a2.662,2.662,0,1,0,2.883,1.737l5.693-5.693a2.662,2.662,0,1,0,.739-5.175ZM43.539,45.043a1.922,1.922,0,1,1,1.922,1.922A1.922,1.922,0,0,1,43.539,45.043Zm1.922,11.016a1.922,1.922,0,1,1,1.922-1.922A1.922,1.922,0,0,1,45.461,56.059Zm8.946-9.094a1.922,1.922,0,1,1,1.922-1.922A1.922,1.922,0,0,1,54.407,46.965Z",
    transform: "translate(-33.817 -33.555)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.662,67.1a2.662,2.662,0,1,0,2.662,2.662A2.662,2.662,0,0,0,69.662,67.1Zm0,4.547a1.922,1.922,0,1,1,1.922-1.922A1.922,1.922,0,0,1,69.662,71.647Z",
    transform: "translate(-49.071 -49.143)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.823,21.214a2.662,2.662,0,1,0-2.883,2.625v3.845a2.625,2.625,0,1,0,.739.037V23.8A2.662,2.662,0,0,0,23.823,21.214Zm-4.547,0A1.922,1.922,0,1,1,21.2,23.137a1.922,1.922,0,0,1-1.922-1.922Zm3.808,9.094a1.922,1.922,0,1,1-1.922-1.922,1.922,1.922,0,0,1,1.922,1.922Z",
    transform: "translate(-18.5 -18.525)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformoverview);
export default __webpack_public_path__ + "static/media/platformoverview.6a406932.svg";
export { ForwardRef as ReactComponent };